import React,{ useEffect }  from "react";

//mobile
import LandingLoading from "../../LandingLoading/LandingLoading";
import LandingMobile from "../../../components/Mobile/landingMobile/LandingMobile";
import DepartmentsMobile from "../../../components/Mobile/DepartmentsMobile/DepartmentsMobile";
import About from "../../../components/Mobile/About/About";
import OurWorkMobile from "../../../components/Mobile/OurWorkMobile/OurWorkMobile";
import MapMobile from "../../../components/Mobile/MapMobile/MapMobile";
import FactsNFiguresMobile from "../../../components/Mobile/FactsNFiguresMobile/FactsNFiguresMobile";
import FooterMobile from "../../../components/Mobile/FooterMobile/FooterMobile";

import { useDispatch } from "react-redux";
import { ScrollActions } from "../../../store/Slices/ScrollSlice";


const HomeMobile = ()=>{
    const dispatch = useDispatch();
    useEffect(()=>{
        return ()=>{
            console.log("RESETTT")
            dispatch(ScrollActions.setInitial())
        }
    },[])

    return <>
    <LandingLoading />
    <LandingMobile />
    <DepartmentsMobile />
    <About />
    <MapMobile />
    <FactsNFiguresMobile />
    <FooterMobile />
    <div id="portal"></div>
  </>
}
export default HomeMobile